import {useEffect, useState} from "react";
import {getMofsScreenshotUrl} from "../../../helpers";
import {MDBCol, MDBContainer, MDBRow} from "mdb-react-ui-kit";
import {renderField} from "./WatchlistDataReviewUtils";
import { Spinner } from "stm-frontend-library";

const MofsHitDetails = (item, index, array) => {
    const [screenshotObject, setScreenshotObject] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const mofsScreenshotResponse = await getMofsScreenshotUrl(item.value);
                setScreenshotObject(mofsScreenshotResponse.data);
            } catch (e) {
                setScreenshotObject({ found: false, signedUrl: '' });
            } finally {
                setIsLoading(false);
            }
        })();
    }, []);

    let renderedScreenshot = <></>;

    if (isLoading) {
        renderedScreenshot = <Spinner />;
    } else {
        if (screenshotObject.found && screenshotObject.signedUrl) {
            renderedScreenshot = <MDBContainer fluid>
                <MDBRow>
                    <MDBCol size={12} md={6}>
                        <img
                            src={screenshotObject.signedUrl}
                            className={'w-100'}
                        />
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        } else {
            renderedScreenshot = <small>Screenshot not found</small>;
        }
    }

    return (
        <div key={index}>
            {renderField("Title", item?.value)}
            {renderField("Provided by", item?.providedby)}
            {renderField("Timestamp", item?.timestamp)}
            {renderField("Comment", item?.comment)}
            <p><strong>Screenshot:</strong></p>
            {renderedScreenshot}
            {index < array.length - 1 && <hr className="hr"/>}
        </div>
    );
};

export default MofsHitDetails;
